import { render, staticRenderFns } from "./ReviewsSlider.vue?vue&type=template&id=495654a0&scoped=true&"
import script from "./ReviewsSlider.vue?vue&type=script&lang=js&"
export * from "./ReviewsSlider.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsSlider.vue?vue&type=style&index=0&id=495654a0&prod&lang=scss&scoped=true&"
import style1 from "./ReviewsSlider.vue?vue&type=style&index=1&id=495654a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495654a0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Container: require('/vercel/path0/components/general/Container.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
